<template>
  <v-container grid-list-lg wrap class="reviewers-list">
    <p class="title">Revisores</p>
    <v-layout align-start justify-center px-5 pb-5 wrap>
      <Lister :items="reviewers" :hideSearchbar="true" :cardBreakpoints="'xs12 md6'">
        <template v-slot:default="slotProps">
          <ReviewerContent :reviewer="slotProps.item"></ReviewerContent>
        </template>
      </Lister>
    </v-layout>
  </v-container>
</template>

<script>
import Lister from '@/components/Lister.vue';
import ReviewerContent from './Content.vue';

export default {
  components: { ReviewerContent, Lister },
  props: {
    reviewers: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped>
  .reviewers-list{
    padding-top: 20px;
    margin-left: -11px;
  }
  .title{
    color: black;
    text-align: left;
  }
</style>
